import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const tok = localStorage.getItem("np_token");
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

// Cuando el backend rechaza una petición porque la empresa está suspendida
// por falta de pago, redirigimos silenciosamente al módulo de pagos y
// suprimimos el error para que no aparezca como toast/overlay al usuario.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const code = typeof detail === "object" ? detail?.code : null;
    if (status === 403 && code === "empresa_suspendida") {
      if (typeof window !== "undefined" && window.location.pathname !== "/pagos") {
        window.location.replace("/pagos");
      }
      // Retornamos una promesa que nunca resuelve para que el .then/.catch
      // aguas arriba no dispare el toast de error mientras redirigimos.
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intentá de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const colones = (n) => {
  if (n == null || isNaN(n)) return "₡0,00";
  return new Intl.NumberFormat("es-CR", { style: "currency", currency: "CRC", minimumFractionDigits: 2 }).format(n);
};

export const todayISO = () => toLocalISO(new Date());

// Formatea un Date como YYYY-MM-DD usando el huso horario LOCAL del navegador.
// Necesario porque .toISOString() convierte a UTC, y para usuarios en Costa Rica
// (UTC-6) cualquier hora ≥ 18:00 se desplaza al día siguiente en UTC — lo que
// causaba que rangos como "Lunes a Domingo" aparecieran corridos 1 día.
export const toLocalISO = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const weekRange = (offset = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + offset * 7);
  const day = d.getDay(); // 0=Dom
  const monday = new Date(d);
  monday.setDate(d.getDate() - ((day + 6) % 7));
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { start: toLocalISO(monday), end: toLocalISO(sunday), monday, sunday };
};

export const monthRange = (year, monthIdx) => {
  const start = new Date(year, monthIdx, 1);
  const end = new Date(year, monthIdx + 1, 0);
  return { start: toLocalISO(start), end: toLocalISO(end) };
};

export const fmtFecha = (iso) => {
  if (!iso) return "";
  // Tolera tanto YYYY-MM-DD como YYYY-MM-DDTHH:MM:SS… → siempre nos quedamos con la fecha.
  const onlyDate = String(iso).slice(0, 10);
  const d = new Date(onlyDate + "T00:00:00");
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("es-CR", { day: "2-digit", month: "short", year: "numeric" });
};

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map(s => s[0]?.toUpperCase()).join("");
